import React from "react";
import "./Features.scss";
import LazyLoad from "react-lazyload";
import { FormattedMessage } from "react-intl";

function Features({ currentLocale }) {
  return (
    <section id="features">
      <div className="feature-wrapper">
        <LazyLoad offset={800} once>
          {currentLocale === "en" ? (
            <>
              <lottie-player
                key="0"
                class="animation1"
                src="animations-en/design/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          ) : (
            <>
              <lottie-player
                key="1"
                class="animation1"
                src="animations-cs/design/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          )}
        </LazyLoad>
        <div className="text">
          <h3>
            <FormattedMessage id="home.features.h1" />
          </h3>
          <p>
            <FormattedMessage id="home.features.p1" />
          </p>
        </div>
      </div>
      <div className="feature-wrapper">
        <div className="text">
          <h3>
            <FormattedMessage id="home.features.h2" />
          </h3>
          <p>
            <FormattedMessage id="home.features.p2" />
          </p>
        </div>
        <LazyLoad offset={800} once>
          {currentLocale === "en" ? (
            <>
              <lottie-player
                key="2"
                class="animation2"
                src="animations-en/samolepky/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          ) : (
            <>
              <lottie-player
                key="3"
                class="animation2"
                src="animations-cs/samolepky/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          )}
        </LazyLoad>
      </div>
      <div className="feature-wrapper">
        <LazyLoad offset={800} once>
          {currentLocale === "en" ? (
            <>
              <lottie-player
                key="4"
                class="animation3"
                src="animations-en/export/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          ) : (
            <>
              <lottie-player
                key="5"
                class="animation3"
                src="animations-cs/export/data.json"
                background="transparent"
                speed="1"
                loop
                autoplay
              ></lottie-player>
            </>
          )}
        </LazyLoad>
        <div className="text">
          <h3>
            <FormattedMessage id="home.features.h3" />
          </h3>
          <p>
            <FormattedMessage id="home.features.p3" />
          </p>
        </div>
      </div>
    </section>
  );
}

export default Features;
